export interface Movie {
  id: string;
  title: string;
  originalTitle: string;
  type: 'movie' | 'tv';
  year: number;
  region: string;
  genres: string[];
  rating: number;
  duration: number;
  episodes: number;
  director: string;
  cast: string[];
  poster: string;
  backdrop: string;
  summary: string;
  synopsis: string;
  releaseDate: string;
  status: string;
  hot: number;
}

export const movies: Movie[] = [
  {
    id: 'beauty-and-the-beast',
    title: '美女与野兽',
    originalTitle: 'Beauty and the Beast',
    type: 'movie',
    year: 2024,
    region: '美国',
    genres: ['奇幻', '爱情', '家庭'],
    rating: 8.6,
    duration: 128,
    episodes: 0,
    director: '丹尼尔·布鲁克斯',
    cast: ['a2', 'a8', 'a12', 'a1'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20fantasy%20film%20poster%20of%20an%20enchanted%20castle%20glowing%20at%20dusk%20with%20a%20single%20crimson%20rose%20in%20the%20foreground%2C%20moody%20dramatic%20lighting%2C%20rich%20teal%20and%20amber%20color%20grading%2C%20atmospheric%20fog%2C%20highly%20detailed%2C%20no%20text&width=400&height=600&seq=poster-beauty-beast-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20grand%20candlelit%20ballroom%20inside%20an%20enchanted%20castle%20with%20floating%20rose%20petals%2C%20dramatic%20warm%20lighting%2C%20deep%20blue%20shadows%2C%20lush%20fantasy%20atmosphere%2C%20highly%20detailed%2C%20no%20text&width=1600&height=900&seq=backdrop-beauty-beast-01&orientation=landscape',
    summary: '一位少女为救父亲踏入受诅咒的城堡，与野兽王子相遇，从恐惧到理解，再到真爱。',
    synopsis: '在常年被浓雾笼罩的山谷深处，矗立着一座被遗忘的城堡。钟表匠的女儿贝儿为救回误入禁地的父亲，独自推开了那扇沉重的铜门。城堡的主人因傲慢而被施以诅咒，只能以野兽之身示人，唯有真挚的爱才能破除魔法。在会说话的烛台与茶壶陪伴下，贝儿逐渐看见粗粝外表下的温柔与孤独。当满园玫瑰凋零的最后一个夜晚来临，她必须做出选择——是逃离，还是留下。',
    releaseDate: '2024-06-14',
    status: '上映中',
    hot: 98,
  },
  {
    id: 'star-ocean',
    title: '星海彼岸',
    originalTitle: 'Beyond the Star Ocean',
    type: 'movie',
    year: 2024,
    region: '美国',
    genres: ['科幻', '冒险', '剧情'],
    rating: 8.9,
    duration: 146,
    episodes: 0,
    director: '丹尼尔·布鲁克斯',
    cast: ['a8', 'a1', 'a7'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20film%20poster%20of%20a%20lone%20astronaut%20silhouette%20against%20a%20vast%20purple%20blue%20nebula%20and%20a%20distant%20ringed%20planet%2C%20epic%20scale%2C%20volumetric%20light%2C%20highly%20detailed%2C%20no%20text&width=400&height=600&seq=poster-star-ocean-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20deep%20space%20scene%20with%20a%20swirling%20nebula%20and%20a%20small%20spaceship%20gliding%20past%20an%20enormous%20ringed%20planet%2C%20deep%20blue%20and%20amber%20accents%2C%20epic%20cinematic%20scale%2C%20no%20text&width=1600&height=900&seq=backdrop-star-ocean-02&orientation=landscape',
    summary: '一支远征队穿越虫洞寻找人类新家园，却发现自己正驶向时间的尽头。',
    synopsis: '地球资源枯竭的最后十年，人类把希望寄托在一艘名为"彼岸号"的远航飞船上。舰长罗伊带领六名船员穿越虫洞，前往一颗被探测到液态水的遥远行星。航行途中，飞船时钟开始莫名倒流，船员们不断重逢已经死去的人。当真相逐渐浮出水面，罗伊意识到他们真正穿越的不是空间，而是时间本身。为了把消息带回家，他必须独自面对一个没有归途的抉择。',
    releaseDate: '2024-03-22',
    status: '上映中',
    hot: 96,
  },
  {
    id: 'changan-hours',
    title: '长安十二时',
    originalTitle: 'Twelve Hours in Chang\'an',
    type: 'movie',
    year: 2023,
    region: '中国大陆',
    genres: ['历史', '动作', '悬疑'],
    rating: 8.4,
    duration: 134,
    episodes: 0,
    director: '顾长风',
    cast: ['a3', 'a6', 'a11'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20historical%20chinese%20film%20poster%20of%20a%20cloaked%20swordsman%20on%20a%20misty%20ancient%20city%20wall%20at%20night%20with%20red%20lanterns%2C%20dramatic%20rim%20light%2C%20moody%20ink%20painting%20tones%2C%20highly%20detailed%2C%20no%20text&width=400&height=600&seq=poster-changan-03&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20aerial%20view%20of%20a%20vast%20ancient%20chinese%20capital%20at%20dusk%20with%20thousands%20of%20glowing%20lanterns%2C%20misty%20atmosphere%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20epic%20scale%2C%20no%20text&width=1600&height=900&seq=backdrop-changan-03&orientation=landscape',
    summary: '一日之内，一城之中，一名死囚必须在十二个时辰内查出刺杀真相。',
    synopsis: '上元灯节前夕，长安城戒备森严。前大理寺少卿裴钺含冤入狱，却在行刑前夜被密召出狱，理由是：有人要在十二个时辰内刺杀节度使，而唯一能读懂凶手暗号的人只有他。随着时辰推移，线索指向朝廷深处一个不该存在的名字。裴钺在旧友与新敌之间周旋，用一场注定无人相信的推理，赌上自己的性命去阻止一场席卷九城的动乱。',
    releaseDate: '2023-12-01',
    status: '已下映',
    hot: 92,
  },
  {
    id: 'fog-city',
    title: '雾都迷案',
    originalTitle: 'The Fog City Case',
    type: 'movie',
    year: 2024,
    region: '英国',
    genres: ['犯罪', '悬疑', '剧情'],
    rating: 8.2,
    duration: 118,
    episodes: 0,
    director: '艾米莉·卡特',
    cast: ['a7', 'a8', 'a9'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20film%20poster%20of%20a%20detective%20in%20a%20trench%20coat%20standing%20under%20a%20gas%20lamp%20on%20a%20foggy%20cobblestone%20street%2C%20moody%20desaturated%20tones%2C%20highly%20detailed%2C%20no%20text&width=400&height=600&seq=poster-fog-city-04&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20foggy%20london%20street%20at%20night%20with%20glowing%20gas%20lamps%20and%20silhouettes%20of%20horse%20carriages%2C%20moody%20atmosphere%2C%20deep%20blue%20and%20muted%20amber%2C%20highly%20detailed%2C%20no%20text&width=1600&height=900&seq=backdrop-fog-city-04&orientation=landscape',
    summary: '浓雾笼罩的旧城接连发生离奇命案，退休警探被迫重返那个他发誓不再回的街区。',
    synopsis: '连续七个雾夜，旧城区都少了一个人。死者没有伤口，没有动机，唯一共同点是都曾在同一所孤儿院生活。退休警探亚瑟被昔日搭档请回警局，却发现这桩案子与他二十年前亲手结案的一起悬案纠缠不清。随着调查深入，他不得不重新审视自己曾经坚信的正义——有些真相，被雾藏了太久，一旦揭开，连他自己也难逃审判。',
    releaseDate: '2024-05-09',
    status: '上映中',
    hot: 88,
  },
  {
    id: 'time-letter',
    title: '时光信笺',
    originalTitle: 'Letters Across Time',
    type: 'movie',
    year: 2023,
    region: '韩国',
    genres: ['爱情', '剧情', '奇幻'],
    rating: 8.1,
    duration: 112,
    episodes: 0,
    director: '金秀妍',
    cast: ['a10', 'a2', 'a6'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20romantic%20drama%20film%20poster%20of%20a%20young%20woman%20holding%20an%20old%20letter%20by%20a%20rainy%20window%2C%20soft%20warm%20bokeh%20lighting%2C%20melancholic%20romantic%20atmosphere%2C%20highly%20detailed%2C%20no%20text&width=400&height=600&seq=poster-time-letter-05&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20cozy%20old%20stationery%20shop%20interior%20with%20stacks%20of%20letters%20and%20warm%20lamp%20light%2C%20rain%20on%20the%20window%2C%20soft%20nostalgic%20atmosphere%2C%20warm%20amber%20and%20teal%20tones%2C%20no%20text&width=1600&height=900&seq=backdrop-time-letter-05&orientation=landscape',
    summary: '一间旧邮局里，积压了三十年的信件忽然开始收到回音。',
    synopsis: '在一条快要被拆除的老街上，有间无人问津的邮局。管理员秀雅负责整理一批因地址不明而从未寄出的信件。某天，她试着按照信封上的旧地址回了一封，没想到三天后竟收到了一封来自1989年的回信。隔着三十多年的时光，两个孤独的人开始用纸笔交换彼此的生活。可当秀雅决定去见信中的人时，她才发现，时间从不会为谁停留。',
    releaseDate: '2023-08-25',
    status: '已下映',
    hot: 79,
  },
  {
    id: 'silent-verdict',
    title: '沉默的证词',
    originalTitle: 'The Silent Verdict',
    type: 'movie',
    year: 2022,
    region: '美国',
    genres: ['剧情', '悬疑', '犯罪'],
    rating: 8.5,
    duration: 130,
    episodes: 0,
    director: '丹尼尔·布鲁克斯',
    cast: ['a7', 'a1', 'a3'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20courtroom%20drama%20film%20poster%20of%20an%20empty%20witness%20stand%20under%20a%20single%20harsh%20spotlight%2C%20tense%20moody%20lighting%2C%20desaturated%20tones%20with%20one%20amber%20glow%2C%20highly%20detailed%2C%20no%20text&width=400&height=600&seq=poster-silent-verdict-06&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20dim%20courthouse%20interior%20with%20rows%20of%20empty%20wooden%20seats%20and%20tall%20windows%2C%20dramatic%20light%20shafts%2C%20tense%20atmosphere%2C%20deep%20blue%20shadows%20and%20amber%20highlights%2C%20no%20text&width=1600&height=900&seq=backdrop-silent-verdict-06&orientation=landscape',
    summary: '一名法援律师接手铁证如山的凶案，却发现唯一的证人从未开口说过一句话。',
    synopsis: '年轻法援律师诺拉接到一桩几乎被判定的案子：被告在案发现场被当场抓获，人证物证俱全。唯一的问题是，指控他的关键证人，是一位从未开口说话的聋哑园丁。所有人都劝诺拉走个过场，可她执意要弄清那双手究竟想表达什么。当她一点点拼凑出被忽略的细节，一桩被警方草草掩盖的旧案也随之浮出水面。真相，往往藏在最沉默的地方。',
    releaseDate: '2022-10-14',
    status: '已下映',
    hot: 84,
  },
  {
    id: 'polar-rescue',
    title: '极地救援',
    originalTitle: 'Polar Rescue',
    type: 'movie',
    year: 2024,
    region: '美国',
    genres: ['冒险', '动作', '剧情'],
    rating: 7.9,
    duration: 124,
    episodes: 0,
    director: '艾米莉·卡特',
    cast: ['a8', 'a11', 'a7'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20adventure%20film%20poster%20of%20a%20lone%20figure%20trudging%20through%20a%20vast%20blizzard%20on%20an%20ice%20field%2C%20cold%20blue%20palette%20with%20a%20warm%20orange%20flare%20in%20the%20sky%2C%20epic%20scale%2C%20highly%20detailed%2C%20no%20text&width=400&height=600&seq=poster-polar-rescue-07&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20arctic%20expedition%20camp%20at%20twilight%20with%20orange%20tents%20glowing%20against%20blue%20ice%20mountains%2C%20blowing%20snow%2C%20epic%20atmosphere%2C%20no%20text&width=1600&height=900&seq=backdrop-polar-rescue-07&orientation=landscape',
    summary: '一场突如其来的极地风暴，把一支科考队困在了冰盖深处。',
    synopsis: '南极科考站接到求救信号时，距离风暴封锁航线只剩不到二十小时。经验丰富的救援飞行员霍尔决定迎着风暴起飞，因为被困者中有他的旧日同僚。冰面在脚下不断开裂，燃料在寒风中急速消耗，每一步都可能成为最后一步。这是一场人与自然的博弈，也是一次对承诺的兑现——绝不把任何人留在冰原之上。',
    releaseDate: '2024-01-19',
    status: '上映中',
    hot: 81,
  },
  {
    id: 'between-mountain-sea',
    title: '山与海之间',
    originalTitle: 'Between the Mountain and the Sea',
    type: 'movie',
    year: 2023,
    region: '中国大陆',
    genres: ['剧情', '家庭'],
    rating: 8.7,
    duration: 108,
    episodes: 0,
    director: '顾长风',
    cast: ['a4', 'a3', 'a12'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20family%20drama%20film%20poster%20of%20an%20old%20fisherman%20and%20a%20young%20girl%20standing%20on%20a%20misty%20coastal%20hill%20at%20dawn%2C%20soft%20natural%20lighting%2C%20gentle%20melancholic%20atmosphere%2C%20muted%20teal%20and%20warm%20tones%2C%20no%20text&width=400&height=600&seq=poster-mountain-sea-08&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20fishing%20village%20on%20a%20misty%20coastline%20at%20sunrise%20with%20wooden%20boats%20and%20layered%20mountains%2C%20serene%20atmosphere%2C%20muted%20teal%20and%20soft%20amber%20tones%2C%20no%20text&width=1600&height=900&seq=backdrop-mountain-sea-08&orientation=landscape',
    summary: '一座即将搬迁的海边小镇，一对渐行渐远的父女，用最后一个夏天告别。',
    synopsis: '小镇因海平面上升被列入搬迁计划，世代以打鱼为生的老陈却固执地留在码头。在城里工作的女儿阿宁被迫返乡办理手续，父女二人积压多年的隔阂在一间老屋里慢慢发酵。整个夏天，他们修理渔船、修补屋顶，也一点点修补着彼此的关系。当最后一批邻居离开，老陈终于说出那句藏了十年的话。原来山海之间，隔着的从不是距离，而是沉默。',
    releaseDate: '2023-06-02',
    status: '已下映',
    hot: 83,
  },
  {
    id: 'dream-park',
    title: '幻梦乐园',
    originalTitle: 'Dream Park',
    type: 'movie',
    year: 2024,
    region: '美国',
    genres: ['奇幻', '喜剧', '家庭'],
    rating: 7.8,
    duration: 106,
    episodes: 0,
    director: '丹尼尔·布鲁克斯',
    cast: ['a12', 'a8', 'a2'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20fantasy%20comedy%20film%20poster%20of%20a%20colorful%20whimsical%20amusement%20park%20floating%20on%20clouds%20at%20night%20with%20glowing%20rides%2C%20playful%20magical%20lighting%2C%20rich%20vibrant%20colors%2C%20highly%20detailed%2C%20no%20text&width=400&height=600&seq=poster-dream-park-09&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20magical%20amusement%20park%20at%20night%20with%20glowing%20carousel%20and%20fireworks%2C%20dreamy%20purple%20and%20orange%20lights%2C%20whimsical%20fantasy%20atmosphere%2C%20no%20text&width=1600&height=900&seq=backdrop-dream-park-09&orientation=landscape',
    summary: '只要睡着就能进入的乐园，唯一的规则是——不能许愿。',
    synopsis: '十岁的米娅在父亲去世后患上了失眠，直到某夜她收到一张没有寄件人的门票，凭票入睡便能进入一座凭空漂浮的乐园。那里有过山车、棉花糖和会说话的旋转木马，唯独入口写着一条规矩：不许许愿。米娅却发现，别人都不记得许过什么，只有她记得。为了找回一段被偷走的记忆，她决定打破规则，哪怕代价是再也进不去。',
    releaseDate: '2024-07-05',
    status: '上映中',
    hot: 76,
  },
  {
    id: 'city-inside',
    title: '城中之城',
    originalTitle: 'City Within the City',
    type: 'tv',
    year: 2024,
    region: '中国大陆',
    genres: ['剧情', '犯罪', '悬疑'],
    rating: 8.3,
    duration: 45,
    episodes: 36,
    director: '顾长风',
    cast: ['a3', 'a4', 'a11', 'a1'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20crime%20drama%20poster%20of%20a%20night%20city%20skyline%20with%20a%20single%20lit%20window%20and%20a%20lone%20figure%20shadow%2C%20moody%20deep%20blue%20tones%20with%20amber%20highlights%2C%20tense%20atmosphere%2C%20no%20text&width=400&height=600&seq=poster-city-inside-10&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20rainy%20modern%20metropolis%20at%20night%20with%20neon%20reflections%20on%20wet%20streets%2C%20moody%20deep%20blue%20and%20amber%20tones%2C%20tense%20urban%20atmosphere%2C%20no%20text&width=1600&height=900&seq=backdrop-city-inside-10&orientation=landscape',
    summary: '一座摩天楼里，白天的白领和夜晚的陌生人，其实住在同一座城。',
    synopsis: '金融新贵程野搬进市中心最高的写字楼，却在深夜加班时发现，同一层的另一间办公室总在凌晨亮着灯。追查之下，他撞见了一个与白昼截然不同的世界——一座藏在城市缝隙里的"城中城"。随着一桩离奇资金案的展开，他的上司、邻居甚至未婚妻都被卷入其中。程野逐渐明白，有些人活着，只是为了成为别人看不见的影子。',
    releaseDate: '2024-04-18',
    status: '热播中',
    hot: 94,
  },
  {
    id: 'undercurrent',
    title: '暗涌',
    originalTitle: 'Undercurrent',
    type: 'tv',
    year: 2023,
    region: '中国香港',
    genres: ['犯罪', '悬疑', '剧情'],
    rating: 8.6,
    duration: 42,
    episodes: 30,
    director: '江野',
    cast: ['a5', 'a11', 'a3'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20crime%20series%20poster%20of%20a%20harbor%20at%20night%20with%20a%20reflection%20of%20a%20silhouette%20in%20the%20dark%20water%2C%20moody%20teal%20and%20amber%20tones%2C%20tense%20noir%20atmosphere%2C%20highly%20detailed%2C%20no%20text&width=400&height=600&seq=poster-undercurrent-11&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20hong%20kong%20harbour%20at%20night%20with%20reflections%20of%20neon%20signs%20on%20dark%20water%2C%20moody%20teal%20and%20amber%20noir%20atmosphere%2C%20ominous%20calm%2C%20no%20text&width=1600&height=900&seq=backdrop-undercurrent-11&orientation=landscape',
    summary: '水面平静，水底却暗流汹涌。一名卧底警察的身份，正被人一步步揭开。',
    synopsis: '卧底阿深在贩毒集团潜伏了整整八年，几乎忘记了自己的真名。就在收网行动前夜，集团内部忽然流传起一份神秘名单，上面赫然写着一个只有警方高层才知道的代号。阿深必须在身份暴露前找出内鬼，却发现真正的敌人并不在对面，而在他身后。当信任成为最奢侈的东西，他只能靠记忆里那点模糊的光，撑过最后的黑夜。',
    releaseDate: '2023-09-15',
    status: '已完结',
    hot: 91,
  },
  {
    id: 'spring-rain',
    title: '春夜喜雨',
    originalTitle: 'Rain on a Spring Night',
    type: 'tv',
    year: 2024,
    region: '韩国',
    genres: ['爱情', '剧情'],
    rating: 8.4,
    duration: 40,
    episodes: 16,
    director: '金秀妍',
    cast: ['a10', 'a2', 'a6'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20romance%20series%20poster%20of%20two%20figures%20sharing%20one%20umbrella%20on%20a%20rainy%20blossom%20lined%20street%2C%20soft%20spring%20lighting%2C%20tender%20warm%20atmosphere%2C%20pastel%20tones%20with%20amber%20glow%2C%20no%20text&width=400&height=600&seq=poster-spring-rain-12&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20rainy%20spring%20street%20lined%20with%20pink%20blossoms%20and%20warm%20streetlights%2C%20two%20silhouettes%20under%20an%20umbrella%2C%20tender%20romantic%20atmosphere%2C%20soft%20teal%20and%20amber%20tones%2C%20no%20text&width=1600&height=900&seq=backdrop-spring-rain-12&orientation=landscape',
    summary: '一位失眠的花店老板，和一位只在雨天出现的常客，慢慢种下了一段春天。',
    synopsis: '花店老板恩彩有个奇怪的习惯——只在下雨天营业。某个雨夜，撑黑伞的男子第一次走进店里，买了一支从未开过花的旧种球。此后每逢雨天他都会来，两人从寥寥数语，到彼此分享那些说不出口的心事。可当春天真正来临，男子却再没有出现。恩彩守着那支终于发芽的种球，等一个不知道会不会到来的雨季。',
    releaseDate: '2024-02-28',
    status: '已完结',
    hot: 87,
  },
  {
    id: 'borderline',
    title: '边境线',
    originalTitle: 'Borderline',
    type: 'tv',
    year: 2023,
    region: '美国',
    genres: ['动作', '犯罪', '惊悚'],
    rating: 7.9,
    duration: 48,
    episodes: 24,
    director: '艾米莉·卡特',
    cast: ['a8', 'a7', 'a9'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20action%20series%20poster%20of%20a%20fence%20at%20a%20desert%20border%20under%20a%20dramatic%20sunset%20with%20a%20lone%20ranger%20silhouette%2C%20tense%20atmosphere%2C%20warm%20orange%20and%20deep%20blue%20tones%2C%20no%20text&width=400&height=600&seq=poster-borderline-13&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20desert%20border%20crossing%20at%20dusk%20with%20headlights%20and%20dust%2C%20tense%20atmosphere%2C%20deep%20blue%20sky%20and%20orange%20horizon%2C%20no%20text&width=1600&height=900&seq=backdrop-borderline-13&orientation=landscape',
    summary: '一条划在地图上的线，隔开了两个国家，也隔开了并肩作战的兄弟。',
    synopsis: '边境巡逻队队长麦克斯在执勤时发现，走私链条的尽头竟指向自己失散多年的弟弟。一边是誓言守护的职责，一边是血脉相连的亲情，他被夹在一条看不见的线上左右为难。随着行动升级，昔日战友接连倒下，麦克斯意识到，真正需要跨越的从来不是国界，而是自己心里的那条线。',
    releaseDate: '2023-11-10',
    status: '已完结',
    hot: 80,
  },
  {
    id: 'dear-doctor',
    title: '亲爱的医生',
    originalTitle: 'Dear Doctor',
    type: 'tv',
    year: 2024,
    region: '中国大陆',
    genres: ['剧情', '家庭'],
    rating: 8.5,
    duration: 44,
    episodes: 32,
    director: '顾长风',
    cast: ['a4', 'a6', 'a1'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20medical%20drama%20poster%20of%20a%20doctor%20in%20a%20dim%20hospital%20corridor%20with%20warm%20light%20from%20a%20window%2C%20compassionate%20mood%2C%20muted%20blue%20and%20soft%20amber%20tones%2C%20highly%20detailed%2C%20no%20text&width=400&height=600&seq=poster-dear-doctor-14&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20quiet%20hospital%20ward%20at%20dawn%20with%20soft%20warm%20light%20through%20tall%20windows%2C%20calm%20hopeful%20atmosphere%2C%20muted%20teal%20and%20amber%20tones%2C%20no%20text&width=1600&height=900&seq=backdrop-dear-doctor-14&orientation=landscape',
    summary: '一位乡镇医生守着一间小诊所三十年，直到一位年轻记者来为他写讣告。',
    synopsis: '县医院要撤并最后一家乡镇诊所，老医生周明山收到通知那天，正好来了一个自称要为他写"人物报道"的年轻记者。起初周明山并不配合，可随着记者翻出一本本泛黄的病历，一段被时间掩埋的往事重新浮现——那个年代，他几乎用一己之力，接住了一个村子所有的生老病死。而记者此行的真正目的，也远比宣传要复杂得多。',
    releaseDate: '2024-08-01',
    status: '热播中',
    hot: 89,
  },
  {
    id: 'mist-detective',
    title: '迷雾侦探社',
    originalTitle: 'The Mist Detective Agency',
    type: 'tv',
    year: 2023,
    region: '日本',
    genres: ['悬疑', '犯罪', '喜剧'],
    rating: 8.0,
    duration: 46,
    episodes: 20,
    director: '高桥凛',
    cast: ['a9', 'a6', 'a10'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20mystery%20series%20poster%20of%20a%20cluttered%20detective%20office%20window%20overlooking%20a%20foggy%20tokyo%20street%2C%20moody%20atmosphere%2C%20deep%20blue%20and%20warm%20lamp%20glow%2C%20no%20text&width=400&height=600&seq=poster-mist-detective-15&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20foggy%20tokyo%20alley%20at%20night%20with%20a%20small%20detective%20agency%20sign%20glowing%2C%20mysterious%20atmosphere%2C%20deep%20blue%20and%20amber%20tones%2C%20no%20text&width=1600&height=900&seq=backdrop-mist-detective-15&orientation=landscape',
    summary: '三个不靠谱的侦探，一间快倒闭的侦探社，却总莫名其妙地破了大案。',
    synopsis: '在东京老城区一条常年被雾笼罩的小巷里，挂着"迷雾侦探社"的旧招牌。社长是个爱睡觉的前刑警，搭档是总在记账本上画画的女生，还有一个自称天才却连方向都认不清的实习生。三人接手的都是些找猫寻狗的琐碎委托，可每次都会阴差阳错地撞进真正的案件里。靠着一点点运气和很多的不甘心，他们竟意外地成了这座城里最难被打败的组合。',
    releaseDate: '2023-07-07',
    status: '已完结',
    hot: 78,
  },
  {
    id: 'last-lighthouse',
    title: '最后一座灯塔',
    originalTitle: 'The Last Lighthouse',
    type: 'movie',
    year: 2024,
    region: '英国',
    genres: ['剧情', '悬疑'],
    rating: 8.3,
    duration: 116,
    episodes: 0,
    director: '艾米莉·卡特',
    cast: ['a7', 'a8'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20of%20a%20lonely%20lighthouse%20on%20a%20rocky%20island%20in%20a%20stormy%20sea%20at%20dusk%2C%20dramatic%20moody%20lighting%2C%20teal%20and%20amber%20tones%2C%20highly%20detailed%2C%20no%20text&width=400&height=600&seq=poster-last-lighthouse-16&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20stormy%20sea%20with%20waves%20crashing%20against%20a%20lone%20lighthouse%20on%20a%20rocky%20island%2C%20dramatic%20dusk%20light%2C%20moody%20teal%20and%20amber%20tones%2C%20no%20text&width=1600&height=900&seq=backdrop-last-lighthouse-16&orientation=landscape',
    summary: '灯塔看守人迎来最后一位接班者，也迎来一个不该出现在岛上的人。',
    synopsis: '这座位于北海孤岛上的灯塔即将自动化，看守人托马斯是坚守这里的最后一人。退休前夜，一场暴风雨把他和年轻的接班者困在了岛上。就在此时，塔下的礁石边漂来了一个失去意识的陌生人。三个人在密闭的灯塔里相处了七天，彼此的身份渐渐变得可疑。当风暴散去，人们才发现，这座灯塔指引的从来不只是航船。',
    releaseDate: '2024-09-06',
    status: '上映中',
    hot: 77,
  },
];

export const regions: string[] = ['全部', '中国大陆', '美国', '中国香港', '英国', '韩国', '日本'];

export const movieGenres: string[] = ['全部', '动作', '科幻', '爱情', '剧情', '悬疑', '犯罪', '奇幻', '历史', '冒险', '家庭', '喜剧', '惊悚'];

export const tvGenres: string[] = ['全部', '剧情', '犯罪', '悬疑', '爱情', '动作', '家庭', '喜剧', '惊悚'];

export const sortOptions: string[] = ['热门', '最新', '评分'];